module.exports = __webpack_public_path__ + "209fd17c00420802f84d226f5967fc1a.png";